<style lang="less" scoped>
  @import "../../../assets/css/table-list.css";
  @import "../report.less";
  .margin-left20{ margin-left: 20px; }
  b{ color: red; }
</style>
<style lang="less">
  .report{
    .ivu-table-border td:nth-child(5) .ivu-table-cell,
    .ivu-table-border td:nth-child(6) .ivu-table-cell{
      padding:0;
      p{
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        padding:10px;
      }
    }
  }
</style>
<template>
  <div class="report">
    <h3 class="title">收支表</h3>
    <div class="margin-bottom-10 header-group">
      <label>周期设置</label>
      <Select class="margin-left10" v-model="d_date_type" @on-change="change_type">
        <Option value="日">日度</Option>
        <Option value="月">月度</Option>
      </Select>
      <DatePicker :value="d_search_date" :clearable="false" type="date" placeholder="选择日期" style="width: 200px" @on-change="change_date"></DatePicker>
    </div>
    <section>
      <Table :columns="d_columns" :data="d_data" border disabled-hover></Table><br>
    </section>
  </div>
</template>
<script>
  import apiReport from '@/api/report.js';
  export default {
    name:'incomeReport',
    data() {
      return {
        d_columns:[
          {
            title: '收款方式',
            key: 'PayWayType',
            align: 'center'
          },
          {
            title: '金额',
            key: 'Money',
            align: 'center',
            render: (h, params) => {
              return h('span',params.row.Money+'元')
            }
          }
        ],
        d_date_type:'日',
        d_search_date: this.to_date(new Date()),
        d_data: []
      };
    },
    methods: {
      to_date(date){
        let moment = require('moment');
        return moment(date).format('YYYY-MM-DD');
      },
      change_date(date){
        this.d_search_date = date;
        this.pull_data();
      },
      change_type(){
        this.pull_data();
      },
      pull_data() {
        apiReport.GetReport5(this.d_date_type,this.d_search_date).then((_data) => {
          if(_data.data.ExeSuccess && _data.data.LoginSuccess){
            let rowList = _data.data.Data;
            if (rowList.length<=0){
              this.d_data = [];
              return;
            }
            let sumMoney = 0;
            for(let item of rowList){
              if(item.PayWayType!=='挂账'){
                sumMoney += Math.abs(item.Money) //某天王竹要求合计是绝对值合计2019-10-10
              }
            }
            rowList.push({
              PayWayType:'合计',
              Money: sumMoney
            })
            this.d_data = rowList;
          }else {
            this.$Message.error(_data.data.Msg);
          }
        });
      },

    },
    created() {
      this.pull_data()
    },

    mounted(){

    }
  }
</script>
